// AddSectionModal.js
import React, { useState } from "react";
import { Modal, ModalBody, ModalFooter, Input } from "reactstrap";
import Select from "react-select";
import { ProjectButton } from "../style";
import { SecondaryButton } from "../../order/style";
import { createSection } from "../service";
import { randomUUID } from "../../common/service";

const AddSectionModal = ({
  shouldShow,
  close,
  toggle,
  projectId,
  currentRoom,
  refreshProjectSummary,
  setNotificationMessage,
  setIsNotificationVisible,
  mutateCurrentRoom,
}) => {
  const sectionTypes = [
    { value: "wardrobe", label: "Wardrobe" },
    { value: "floor_unit", label: "Floor Unit" },
    { value: "wall_unit", label: "Wall Unit" },
    { value: "loft", label: "Loft" },
  ];

  const [addSectionData, setAddSectionData] = useState({
    name: "",
    type: "wardrobe",
    dimensions: { height: "1000", width: "2500", depth: "550" },
    modules: [],
  });

  const handleAddSection = () => {
    const tempId = randomUUID();

    const sectionData = {
      ...addSectionData,
      temp_id: tempId,
      name:
        addSectionData.name ||
        sectionTypes.find((type) => type.value === addSectionData.type).label,
    };

    currentRoom.groups.push(sectionData);
    mutateCurrentRoom();
    close();

    createSection(sectionData, projectId, currentRoom.id)
      .then((response) => {
        response.temp_id = null;

        // FIXME. Setting position since it's null.
        response.position = { x: 0, y: 0 };
        Object.assign(sectionData, response);
        mutateCurrentRoom();
        refreshProjectSummary();
      })
      .catch(({ error }) => {
        setIsNotificationVisible(true);
        setNotificationMessage({
          type: "error",
          message: error?.message || "Failed to add item.",
        });
      });
  };

  return (
    <Modal isOpen={shouldShow} backdrop="static">
      <ModalBody className="d-flex flex-column row-gap-3">
        <div>
          <p className="mb-1 text-secondary">Section Type</p>
          <Select
            value={sectionTypes.find(
              (type) => type.value === addSectionData.type
            )}
            onChange={(e) =>
              setAddSectionData({
                ...addSectionData,
                type: e.value,
              })
            }
            options={sectionTypes}
          />
        </div>
        <div>
          <p className="mb-1 text-secondary">Name</p>
          <Input
            value={
              addSectionData.name ||
              sectionTypes.find((type) => type.value === addSectionData.type)
                .label
            }
            onChange={(e) =>
              setAddSectionData({
                ...addSectionData,
                name: e.target.value,
              })
            }
          />
        </div>
        <div className="d-flex column-gap-3">
          <div>
            <p className="mb-1 text-secondary">Height</p>
            <Input
              value={addSectionData.dimensions.height}
              onChange={(e) =>
                setAddSectionData({
                  ...addSectionData,
                  dimensions: {
                    ...addSectionData.dimensions,
                    height: e.target.value,
                  },
                })
              }
            />
          </div>
          <div>
            <p className="mb-1 text-secondary">Width</p>
            <Input
              value={addSectionData.dimensions.width}
              onChange={(e) =>
                setAddSectionData({
                  ...addSectionData,
                  dimensions: {
                    ...addSectionData.dimensions,
                    width: e.target.value,
                  },
                })
              }
            />
          </div>
          <div>
            <p className="mb-1 text-secondary">Depth</p>
            <Input
              value={addSectionData.dimensions.depth}
              onChange={(e) =>
                setAddSectionData({
                  ...addSectionData,
                  dimensions: {
                    ...addSectionData.dimensions,
                    depth: e.target.value,
                  },
                })
              }
            />
          </div>
        </div>
      </ModalBody>
      <ModalFooter>
        <ProjectButton
          className="rounded-1"
          onClick={() =>
            handleAddSection(projectId, currentRoom.id, addSectionData)
          }
        >
          Add Section
        </ProjectButton>
        <SecondaryButton onClick={() => close()}>Cancel</SecondaryButton>
      </ModalFooter>
    </Modal>
  );
};

export default AddSectionModal;
